import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';
import type { RootState, AppDispatch } from '@store/store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { setVertical } from './verticalSlice';
export type { VerticalState } from './verticalSlice';

export const useVertical = () =>
  useAppSelector((state) => state.vertical.vertical);

export const useVerticalConfig = () =>
  useAppSelector((state) => state.vertical.config);

export const useVerticalFeatures = () =>
  useAppSelector((state) => state.vertical.config.features);

export const useLoginFeatures = () =>
  useAppSelector((state) => state.vertical.config.features.login);

export const useDashboardFeatures = () =>
  useAppSelector((state) => state.vertical.config.features.dashboard);

export const useEvaluationFeatures = () =>
  useAppSelector((state) => state.vertical.config.features.evaluation);

export const useThemeConfig = () =>
  useAppSelector((state) => state.vertical.config.theme);

export const useBrandingConfig = () =>
  useAppSelector((state) => state.vertical.config.branding);

export const useLoginGateway = () =>
  useAppSelector((state) => state.vertical.config.gatewayConfiguration);

export const useVerticalInitialized = () =>
  useAppSelector((state) => state.vertical.isInitialized);
